export default __webpack_public_path__ + "static/media/star_yellow.6660c9ec.svg";